export default __webpack_public_path__ + "static/media/video_mobile.fd8068fa.mp4";